export function useMapShipperAddress(data, modelValue) {

    modelValue.shipper.shipperContacts = [];

    modelValue.shipper.id = data.id;
    modelValue.shipper.shipperAddressLine1 = data.addressLine1;
    modelValue.shipper.shipperAddressLine2 = data.addressLine2;
    modelValue.shipper.shipperCity = data.city;

    if (data.country) {
        modelValue.shipper.shipperCountry = modelValue.metaData.countries.find(c => c.id === data.country).value;
    }

    modelValue.shipper.shipperCounty = data.county;
    modelValue.shipper.shipperPostcode = data.postCode;
    modelValue.shipper.shipperVatNumber = data.vatNumber;

    modelValue.isUpdate.shipper = true;

    if(data.contacts) {

        data.contacts.forEach(contact => {
            modelValue.shipper.shipperContacts.push(contact)
        })

    }

}
